{
  "name": "@ns/public-ledger-platform-top-up",
  "version": "1.0.0",
  "description": "nodeStream's public ledger account is low: top it up to its target, then enter the new total so the ledger can be checked",
  "inputs": {},
  "outcomes": {
    "topped-up": {
      "serverOnly": true,
      "inputs": {
        "enteredTotalCredits": {
          "type": "number",
          "optional": true
        }
      }
    }
  }
}
